const FLAG_KEY = 'ptafamily_login';
export const NO_SHOW_KEY = 'showPostloginModal';

export function setPTAFamilyLoginFlag(): void {
    sessionStorage.setItem(FLAG_KEY, '1');
}

/**
 * TODO: Refactor: consumePTAFamilyLoginFlag() util depends on composable, but should be a
 * pure standalone function or a composable itself.
 * Works currently because it's called in onMounted().
 */
export function consumePTAFamilyLoginFlag(): boolean {
    if (import.meta.server) return false;

    const flagString = sessionStorage.getItem(FLAG_KEY);
    if (!flagString) return false;

    const router = useRouter();
    // prevent double execution during SSO login flow
    if ('sso-nonce' in router.currentRoute.value.query) return false;
    sessionStorage.removeItem(FLAG_KEY);

    const { isPtaFamily } = usePlatformMeta();
    if (!isPtaFamily.value) return false;
    if (localStorage.getItem(NO_SHOW_KEY) === '0') return false;

    return true;
}
